import React from 'react';
import { Box, Typography, Grid2 } from '@mui/material';
import RatingButton from '../RatingButton/RatingButton';
import RatingImage from '../../assets/rating-img.jpg'
import RatingCard from '../RatingCard/RatingCard';
// import GiftSubHero from '../SubHero/SubHero';
// import { More } from '@mui/icons-material';
import MoreGifts from '../MoreItems/MoreItems';

const DetailsRating = () => {
  const rating__card = [
    {
      title:'Emily R',
      image:RatingImage,
      rating:1,
      description:'Absolutely stunning! The bouquet exceeded my expectations. The flowers were fresh, vibrant, and smelled amazing. It made the perfect gift for my anniversary.'
    },
    {
      title:'Daniel K.',
      image:RatingImage,
      rating:3,
      description:'The arrangement was elegant and beautifully crafted. The attention to detail is unmatched, and it arrived in perfect condition. Worth every penny.'
    },
    {
      title:'Sarah L.',
      image:RatingImage,
      rating:2,
      description:'A gorgeous bouquet that brightened up my mom’s birthday! The flowers lasted over a week, though I wish the delivery had been faster.'
    },
  ]
  return (
    <Box>
      <Box>
        <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center',fontFamily: theme=> theme.typography.smallText,}}>
          <Typography variant='h6' sx={{color:'rgba(18, 18, 18, 0.8)', my:2, fontSize:{xs:'1rem', fontWeight:'600', md:'2rem'}}}>
            Rating & Reviews
          </Typography>
          <RatingButton rating={4.5}/>
        </Box>
        <Typography sx={{color:'rgba(18, 18, 18, 0.8)', my:1}}>
          See what our customers are saying! Real feedback from those who have experienced the beauty of our luxury flower bouquets. Your opinion matters to us
        </Typography>
      </Box>
      <Grid2 container spacing={6} justifyContent={'space-between'} sx={{fontFamily: theme=> theme.typography.smallText,}}>
        {
          rating__card.map((item, index)=>{
            return <RatingCard key={index} title={item?.title} description={item?.description} image={item?.image} rating={item?.rating}/>
          })
        }
      </Grid2>
      {/* <GiftSubHero/> */}
      <MoreGifts/>
    </Box>
  )
}

export default DetailsRating